module.exports = __webpack_public_path__ + "static/img/$5.5.2afe117.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/$5.5.png
// module id = eyzI
// module chunks = 0